import { ListPage } from '@components/molecules';
import { TextFieldElement } from 'react-hook-form-mui';
import API from '@apps/nnc/services/cause';
import { ModelProps } from '@/types';
import { CauseSchema } from '@apps/nnc/schemas/cause';
import { GridColDef } from '@mui/x-data-grid';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SearchSchema } from '@/defaultschemas/search';
import { YesNoAutocompleteElement } from '@/components/atoms';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';
import UnitAPI from '@apps/localization/services/unit';
import OriginAPI from '@apps/nnc/services/origin';

export default function ObjectListPage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('Name'),
      flex: 1,
    },
    {
      field: 'units_str',
      headerName: t('Unit'),
      flex: 1,
    },
    {
      field: 'origin',
      headerName: t('Origin'),
      flex: 1,
      renderCell: (params) => {
        return params.row.origin ? params.row.origin.label : '';
      },
    },
    {
      field: 'order',
      headerName: t('Order'),
    },
    {
      field: 'is_active',
      headerName: t('Is Active?'),
      type: 'boolean',
    },
  ];

  return (
    <ListPage
      schema={CauseSchema}
      schemaSearch={SearchSchema}
      title={t('Cause List')}
      api={API}
      columns={columns}
      modelProps={modelProps}
      initialState={{
        sorting: {
          sortModel: [{ field: 'name', sort: 'asc' }],
        },
      }}
    >
      <Grid size={{ xs: 12, md: 4 }}>
        <TextFieldElement name="search" label={t('Search')} fullWidth />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <AsyncAutocompleteElement
          api={() => UnitAPI.select({ is_active: 1 })}
          name="units"
          label={t('Unit')}
          multiple
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3.5 }}>
        <AsyncAutocompleteElement
          name="origin"
          label={t('Origin')}
          api={() => OriginAPI.select({ is_active: 1 })}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <YesNoAutocompleteElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </ListPage>
  );
}
